import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MarineInsuranceManagementModel } from '@data-layer/models/marine-insurance';
import { ManagementDocumentModel } from '@data-layer/models/management';
import { enumDocumentState } from '@app/data-layer/enums/documents';
import { DocumentStateUpdateModel } from '@app/data-layer/models/documents';

@Component({
  selector: 'app-marine-insurance-quote-management-view-card',
  templateUrl: './marine-insurance-quote-management-view-card.component.html',
  styleUrls: ['./marine-insurance-quote-management-view-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceQuoteManagementViewCardComponent {
  @Input() public marineInsurance: MarineInsuranceManagementModel;
  @Input() public documents: ManagementDocumentModel[] = [];
  @Output() public documentStateUpdate: EventEmitter<DocumentStateUpdateModel> = new EventEmitter<DocumentStateUpdateModel>();
  @Output() public uploadCertificate: EventEmitter<void> = new EventEmitter<void>();

  public isShowHistory: boolean;

  public toggleHistory(): void {
    this.isShowHistory = !this.isShowHistory;
  }

  public onDocumentStateUpdate(documentId: number, state: enumDocumentState) {
    this.documentStateUpdate.emit({ documentId, state });
  }

  public get documentsList(): ManagementDocumentModel[] {
    if (!this.documents?.length) {
      return [];
    }

    const sortedDocs: ManagementDocumentModel[] = this.documents.sort((a: ManagementDocumentModel, b: ManagementDocumentModel) => {
      if (a.createdDate < b.createdDate) {
        return 1;
      }
      if (a.createdDate > b.createdDate) {
        return -1;
      }

      return 0;
    });

    return this.isShowHistory ? sortedDocs : [sortedDocs[0]];
  }
}
